import axios from 'axios';
import qs from 'qs';
import inquiryResponseMessage from '@component_path/lib/call_api/inquiry_mail/inquiryResponseMessage';

export const redirectToThanksPageUrlWithParams = ({
  thanksPageUrl,
  response
}) => {
  const thanksPageUrlString = thanksPageUrl.split('?')[0] || thanksPageUrl; 
  const thanksPageUrlQueryParams = qs.parse(thanksPageUrl.split('?')[1] || '');
  const responseData = response.data;
  delete responseData.result;
  const redirectQueryParams = qs.stringify(Object.assign({}, thanksPageUrlQueryParams, responseData))
  const thanksPageUrlWithParams = `${thanksPageUrlString}?${redirectQueryParams}`;
  location.href = thanksPageUrlWithParams;
}

export const handlePostInquiryMail = async ({
  inquiryUrl,
  thanksPageUrl,
  requestBody,
  resolve,
  reject = (error) => error,
  finish = () => {}
}) => {
  return await axios
    .post(inquiryUrl, requestBody)
    .then((response) => {
      if(resolve !== undefined) {
        return resolve(response);
      }else{
        location.href = thanksPageUrl;
      }
    })
    .catch((error) => {
      alert(inquiryResponseMessage[error.response.status]);
      return reject(error);
    })
    .finally(() => {
      return finish();
    });
}